import { AM_NAME as NAME, AM_DISPLAY_NAME as DISPLAY_NAME } from '../../constants/Destinations';

const DIR_NAME = 'Amplitude';
const AMPLITUDE_SDK_VERSION_CONFIG_KEY = 'sdkVersion';
const AMPLITUDE_AUTO_CAPTURE_PAGE_VIEWS_CONFIG_KEY = 'enablePageViewsAutoCapture';
const AMPLITUDE_PAGE_URL_ENRICHMENT_CONFIG_KEY = 'enablePageUrlEnrichmentAutoCapture';
const AMPLITUDE_TRACK_SESSION_EVENTS_CONFIG_KEY = 'trackSessionEvents';
const AMPLITUDE_WEB_VITALS_CONFIG_KEY = 'enableWebVitalsAutoCapture';
const AMPLITUDE_FILE_DOWNLOADS_CONFIG_KEY = 'enableFileDownloadsAutoCapture';
const AMPLITUDE_FRUSTRATION_INTERACTIONS_CONFIG_KEY = 'enableFrustrationInteractionsAutoCapture';
const AMPLITUDE_NETWORK_TRACKING_CONFIG_KEY = 'enableNetworkTrackingAutoCapture';
const AMPLITUDE_ELEMENT_INTERACTIONS_CONFIG_KEY = 'enableElementInteractionsAutoCapture';
const AMPLITUDE_FORM_INTERACTIONS_CONFIG_KEY = 'enableFormInteractionsAutoCapture';
const AMPLITUDE_SDK_V1 = 1;
const AMPLITUDE_SDK_V2 = 2;

const CNameMapping = {
  [NAME]: NAME,
  AMPLITUDE: NAME,
  Amplitude: NAME,
  am: NAME,
};

export {
  NAME,
  CNameMapping,
  DISPLAY_NAME,
  DIR_NAME,
  AMPLITUDE_SDK_VERSION_CONFIG_KEY,
  AMPLITUDE_AUTO_CAPTURE_PAGE_VIEWS_CONFIG_KEY,
  AMPLITUDE_PAGE_URL_ENRICHMENT_CONFIG_KEY,
  AMPLITUDE_TRACK_SESSION_EVENTS_CONFIG_KEY,
  AMPLITUDE_WEB_VITALS_CONFIG_KEY,
  AMPLITUDE_FILE_DOWNLOADS_CONFIG_KEY,
  AMPLITUDE_FRUSTRATION_INTERACTIONS_CONFIG_KEY,
  AMPLITUDE_NETWORK_TRACKING_CONFIG_KEY,
  AMPLITUDE_ELEMENT_INTERACTIONS_CONFIG_KEY,
  AMPLITUDE_FORM_INTERACTIONS_CONFIG_KEY,
  AMPLITUDE_SDK_V1,
  AMPLITUDE_SDK_V2,
};
